import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import MerchantHeader from "../../components/Merchant/MerchantHeader";
import MerchantTable from "../../components/Merchant/MerchantTable";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { getFormattedMerchantListResponse } from "../../helper";
import { fetchAllMerchants } from "../../services/merchantService";
const CURRENT_PAGE = 1;
const LIMIT = 10;
const QUERY = "";

const Merchant = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [totalMerchants, setTotalMerchants] = useState(0);
  const [query, setQuery] = useState(QUERY);
  const [currentPage, setCurrentPage] = useState(CURRENT_PAGE);
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isTableDataLoading, setTableLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchMerchants(page, LIMIT, query);
  };

  useEffect(() => {
    fetchMerchants(CURRENT_PAGE, LIMIT, QUERY);
  }, []);

  const fetchMerchants = async (
    activePage: number,
    limitCount: number,
    queryString: string
  ) => {
    setTableLoader(true);
    try {
      let { data } = await fetchAllMerchants(
        activePage,
        limitCount,
        queryString
      );
      if (data.code === 200) {
        let formattedData = getFormattedMerchantListResponse(data.data);
        setTableLoader(false);
        setTotalMerchants(data.count);
        setData(formattedData);
      }
    } catch (error: any) {
      setTableLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleEdit = (id: string) => {
    navigate(`/admin/edit-merchant/${id}`);
  };

  const handleSearch = (value: string) => {
    setQuery(value);
    setCurrentPage(1);
    fetchMerchants(1, LIMIT, value);
  };

  return (
    <MechantPageContainer>
      <MerchantHeader onSearch={handleSearch} query={query} />
      <MerchantTable
        onPageChange={(page) => handlePageChange(page)}
        totalData={totalMerchants}
        currentPage={currentPage}
        rowsPerPage={LIMIT}
        data={data}
        onEdit={handleEdit}
        isTableDataLoading={isTableDataLoading}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
    </MechantPageContainer>
  );
};

const MechantPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default Merchant;
